import $ from 'cash-dom';
import prestashop from 'prestashop';

prestashop.responsive = prestashop.responsive || {};

prestashop.responsive.current_width = window.innerWidth;
prestashop.responsive.min_width = 768;
prestashop.responsive.mobile = prestashop.responsive.current_width < prestashop.responsive.min_width;

function swapChildren(obj1, obj2) {
  const temp = [...obj2.children];

  while (obj1.firstChild) {
    obj2.appendChild(obj1.firstChild);
  }

  temp.forEach(child => obj1.appendChild(child));
}

function toggleMobileStyles() {
  if (prestashop.responsive.mobile) {
    document.querySelectorAll('[id^="_desktop_"]').forEach((el) => {
      const targetId = el.id.replace('_desktop_', '_mobile_');
      const target = document.getElementById(targetId);

      if (target) {
        swapChildren(el, target);
      }
    });
  } else {
    document.querySelectorAll('[id^="_mobile_"]').forEach((el) => {
      const targetId = el.id.replace('_mobile_', '_desktop_');
      const target = document.getElementById(targetId);

      if (target) {
        swapChildren(el, target);
      }
    });
  }

prestashop.emit('responsive update', {
  mobile: prestashop.responsive.mobile,
});
}

window.addEventListener('resize', () => {
  const cw = prestashop.responsive.current_width;
  const mw = prestashop.responsive.min_width;
  const w = window.innerWidth;

  const toggle = (cw >= mw && w < mw) || (cw < mw && w >= mw);

  prestashop.responsive.current_width = w;
  prestashop.responsive.mobile = prestashop.responsive.current_width < prestashop.responsive.min_width;

  if (toggle) {
    toggleMobileStyles();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (prestashop.responsive.mobile) {
    toggleMobileStyles();
  };
});
